import PropTypes from "prop-types";
import { createContext, useContext, useState } from "react";
import api from "../common/api/api";
import { toast } from "react-toastify";

export const RefundContext = createContext();

export const RefundProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [refundLoading, setRefundLoading] = useState(false);

  const getTransactionsList = async (request) => {
    setLoading(true);
    try {
      const response = await api.refunds.getTransactions(request);
      if (response?.success) {
        const docs = Array.isArray(response?.data?.docs)
          ? response.data.docs
          : Array.isArray(response?.data)
            ? response.data
            : [];
        const total = response?.data?.totalDocs !== undefined
          ? response.data.totalDocs
          : docs.length;

        setTransactions(docs);
        setTotalCount(total);
        setTotalPages(response?.data?.totalPages || 1);
      } else {
        setTransactions([]);
        setTotalCount(0);
        setTotalPages(0);
      }
    } catch (error) {
      console.error("getTransactionsList API Error:", error);
      toast.error(error?.message || "Failed to fetch transactions list.");
      setTransactions([]);
      setTotalCount(0);
      setTotalPages(0);
    } finally {
      setLoading(false);
    }
  };

  const processAdminRefund = async (request) => {
    setRefundLoading(true);
    try {
      const response = await api.refunds.refundTransaction(request);
      if (response?.success) {
        toast.success(response?.message || "Refund processed successfully!");
        return true;
      } else {
        toast.error(response?.message || "Refund failed.");
        return false;
      }
    } catch (error) {
      toast.error(error?.message || "Failed to process refund.");
      return false;
    } finally {
      setRefundLoading(false);
    }
  };

  const contextValue = {
    loading,
    transactions,
    totalCount,
    totalPages,
    refundLoading,
    getTransactionsList,
    processAdminRefund,
  };

  return (
    <RefundContext.Provider value={contextValue}>{children}</RefundContext.Provider>
  );
};

RefundProvider.propTypes = {
  children: PropTypes.node,
};

export const useRefund = () => useContext(RefundContext);
